import React, { useState, useEffect } from "react"
import Modal from "../Modal"
import ContactModal from "../ContactModal"
import ContactList from "../ContactList"
import ConfirmacaoNovaConversaModal from "../ConfirmacaoNovaConversaModal"
import FiltroNovaConversa from "./components/filtroNovaConversa"

const NovaConversaModal = ({ modalOpen, onClose }) => {
  const [mContatoSelecionado, setMContatoSelecionado] = useState([])
  const [searchParam, setSearchParam] = useState("")
  const [chipFilter, setChipFilter] = useState(0)
  const [contactModalOpen, setContactModalOpen] = useState(false)
  const [openConfimationModal, setOpenConfimationModal] = useState(false)

  const handleAddNewContactTicket = (contact) => {
    // Formata o contato no padrão esperado pelo ConfirmacaoNovaConversaModal
    const oContatoFormatado = {
      id: contact.id,
      nome: contact.name,
      numero: contact.number,
      email: contact.email || "",
      empresa: contact.empresa || "",
      profilePicUrl: contact.profilePicUrl || "",
      canalTipoId: contact.canalTipoId,
      imagemPerfil: contact.profilePicUrl || "",
    }
    setMContatoSelecionado([oContatoFormatado])
  }

  const cleanFunc = () => {
    setSearchParam("")
    setChipFilter(0)
    setMContatoSelecionado([])
  }

  useEffect(() => {
    if (mContatoSelecionado.length === 1) {
      setOpenConfimationModal(true)
    }
  }, [mContatoSelecionado])

  return (
    <>
      <ContactModal
        open={contactModalOpen}
        initialValues={{ name: searchParam }}
        onClose={() => setContactModalOpen(false)}
        onSave={handleAddNewContactTicket}
      />
      <ConfirmacaoNovaConversaModal
        modalOpen={openConfimationModal}
        initialContact={mContatoSelecionado[0]}
        onClose={(ticket) => {
          setMContatoSelecionado([])
          setOpenConfimationModal(false)
          if (ticket) {
            onClose(ticket)
            cleanFunc()
          }
        }}
      />

      <Modal title="Nova conversa" modalOpen={modalOpen} onClose={onClose} cleanFunc={cleanFunc} tipoModal="encaminhar">
        {/* Campo simples de busca */}
        <FiltroNovaConversa
          setSearchParam={setSearchParam}
          searchParam={searchParam}
          chipFilter={chipFilter}
          setChipFilter={setChipFilter}
        />

        {/* Lista de contatos */}
        <ContactList
          canalFilter={chipFilter}
          searchParam={searchParam}
          setContactModalOpen={setContactModalOpen}
          setMContatosSelecionados={setMContatoSelecionado}
          mContatosSelecionados={mContatoSelecionado}
        />
      </Modal>
    </>
  )
}

export default NovaConversaModal
